import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTitle } from '../TitleContext';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Alert,
} from '@mui/material';

function RegisterSmaregiAccount() {
  const { defaultTitle } = useTitle();
  const [input, setInput] = useState({
    lastName: '',
    firstName: '',
    lastKana: '',
    firstKana: '',
    sex: '0',
    birthDate: '', // ← 送信用の文字列
    phoneNumber: '',
    mailAddress: '',
    postCode: '',
    address: '',
  });

  // 生年月日選択用
  const [birthYear, setBirthYear] = useState('');
  const [birthMonth, setBirthMonth] = useState('');
  const [birthDay, setBirthDay] = useState('');

  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const fetchAddressByPostCode = async (zipcode) => {
    try {
      if (!zipcode) return;
      const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`);
      const data = await response.json();
      if (data.results) {
        const result = data.results[0];
        const newAddress = `${result.address}`;
        setInput((prev) => ({ ...prev, address: newAddress }));
      } else {
        console.log('住所が見つかりませんでした');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePostCodeBlur = () => {
    fetchAddressByPostCode(input.postCode);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResult(null);

    const birthDateStr = `${birthYear}-${birthMonth.padStart(2, '0')}-${birthDay.padStart(2, '0')}`;
    const fullInput = { ...input, birthDate: birthDateStr };

    try {
      const response = await fetch('https://mfcapi.ykvario.com/smaregiHandler.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(fullInput),
      });

      if (!response.ok) {
        const errData = await response.json();
        setError(errData?.message || 'Failed');
        return;
      }

      const data = await response.json();
      setResult(data);
      localStorage.setItem('customerCode', data.customerCode);
      localStorage.setItem('customerId', data.customerId);
      navigate('/account');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div>
      <Helmet>
        <title>{`${defaultTitle} - 会員登録`}</title>
      </Helmet>
      <Container maxWidth="sm">
        <Box sx={{ mt: 4 , mb: 2}}>
          <Box sx={{ height: '10px' }} /> {/* 上部スペーサー追加 */}
          <Typography variant="h4" textAlign="center" fontWeight="bold" gutterBottom>
            スマレジ会員登録
          </Typography>

          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              {/* 氏名・カナ */}
              <Grid item xs={6}><TextField fullWidth label="姓" name="lastName" value={input.lastName} onChange={handleChange} sx={{ backgroundColor: '#fff' }}/></Grid>
              <Grid item xs={6}><TextField fullWidth label="名" name="firstName" value={input.firstName} onChange={handleChange} sx={{ backgroundColor: '#fff' }}/></Grid>
              <Grid item xs={6}><TextField fullWidth label="セイ" name="lastKana" value={input.lastKana} onChange={handleChange} sx={{ backgroundColor: '#fff' }}/></Grid>
              <Grid item xs={6}><TextField fullWidth label="メイ" name="firstKana" value={input.firstKana} onChange={handleChange} sx={{ backgroundColor: '#fff' }}/></Grid>

              {/* 性別 */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" gutterBottom>性別</Typography>
                <FormControl fullWidth>
                  <Select labelId="sex-label" name="sex" value={input.sex} onChange={handleChange} sx={{ backgroundColor: '#fff' }}>
                    <MenuItem value="0">未選択</MenuItem>
                    <MenuItem value="1">男性</MenuItem>
                    <MenuItem value="2">女性</MenuItem>
                    <MenuItem value="3">その他</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* 生年月日（3セレクト形式） */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" gutterBottom>生年月日</Typography>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel>年</InputLabel>
                      <Select value={birthYear} onChange={(e) => setBirthYear(e.target.value)} label="年" sx={{ backgroundColor: '#fff' }}>
                        {[...Array(100)].map((_, i) => {
                          const year = new Date().getFullYear() - i;
                          return <MenuItem key={year} value={year.toString()}>{year}年</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel>月</InputLabel>
                      <Select value={birthMonth} onChange={(e) => setBirthMonth(e.target.value)} label="月" sx={{ backgroundColor: '#fff' }}>
                        {Array.from({ length: 12 }, (_, i) => (
                          <MenuItem key={i + 1} value={(i + 1).toString()}>{i + 1}月</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel>日</InputLabel>
                      <Select value={birthDay} onChange={(e) => setBirthDay(e.target.value)} label="日" sx={{ backgroundColor: '#fff' }}>
                        {Array.from({ length: 31 }, (_, i) => (
                          <MenuItem key={i + 1} value={(i + 1).toString()}>{i + 1}日</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              {/* その他 */}
              <Grid item xs={12} sm={6}><TextField fullWidth label="電話番号" name="phoneNumber" value={input.phoneNumber} onChange={handleChange} sx={{ backgroundColor: '#fff' }}/></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="メールアドレス" type="email" name="mailAddress" value={input.mailAddress} onChange={handleChange} sx={{ backgroundColor: '#fff' }}/></Grid>
              <Grid item xs={12} sm={6}><TextField fullWidth label="郵便番号" name="postCode" value={input.postCode} onChange={handleChange} onBlur={handlePostCodeBlur} sx={{ backgroundColor: '#fff' }}/></Grid>
              <Grid item xs={12}><TextField fullWidth label="住所" name="address" value={input.address} onChange={handleChange} sx={{ backgroundColor: '#fff' }}/></Grid>
            </Grid>

            <Button type="submit" variant="contained" color="primary" sx={{ fontSize: '1.3em', mt: 3, px: '3em', display: 'block', mx: 'auto' }}>
              登録
            </Button>
          </Box>

          {error && <Alert severity="error" sx={{ mt: 2 }}>エラー: {error}</Alert>}
          {result && (
            <Alert severity="success" sx={{ mt: 2 }}>
              <Typography variant="body1" sx={{ mb: 0.5 }}>登録が完了しました！</Typography>
              <Typography variant="body2">CustomerCode: {result.customerCode}</Typography>
              <Typography variant="body2">CustomerId: {result.customerId}</Typography>
            </Alert>
          )}
        </Box>
      </Container>
    </div>
  );
}

export default RegisterSmaregiAccount;
